import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker, Form, Select, Row, Col, Input } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { defaultFiltersConfig } from '../../../utils/dataFilter';
import helpers from '../../../utils/helpers';
import styles from '../styles.less';

const FormItem = Form.Item;
const { Search } = Input;
const { RangePicker } = DatePicker;

function CustomizedForm(props) {
  const filterChange = (name, value) => {
    props.onChange({ [name]: value });
  };

  return (
    <Form className={styles.targetGroup}>
      <Row gutter={15} type="flex" align="top" justify="start" className={styles.filters}>
        <Col xs={24} sm={8} md={24} lg={8}>
          <FormItem colon={false}>
            <RangePicker
              placeholder={[
                props.intl.formatMessage({ id: 'Common.StartDate' }),
                props.intl.formatMessage({ id: 'Common.EndDate' }),
              ]}
              onChange={e => filterChange('dateRange', e)}
              format={props.dateFormat}
            />
          </FormItem>
        </Col>
        <Col xs={24} sm={8} md={24} lg={8}>
          <FormattedMessage id="Component.LeadsVisitsFilter.Score">
            {msg => (
              <FormItem colon={false}>
                <Select
                  placeholder={msg}
                  filterOption={helpers.multipleSelectFilter}
                  onChange={e => filterChange('score', e)}
                >
                  {defaultFiltersConfig.allScores.map(
                    item => (<Select.Option key={item.value} value={item.value}>
                      {item.label}
                    </Select.Option>),
                  )}
                </Select>
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
        <Col xs={24} sm={8} md={24} lg={8}>
          <FormattedMessage id="Component.LeadsVisitsFilter.Campaign">
            {msg => (
              <FormItem colon={false}>
                <Search
                  maxLength={255}
                  placeholder={msg}
                  onSearch={e => filterChange('campaign', e)}
                />
              </FormItem>
            )}
          </FormattedMessage>
        </Col>
      </Row>
    </Form>
  );
}

CustomizedForm.propTypes = {
  dateFormat: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default (injectIntl(CustomizedForm));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadDetailsFilter/LeadDetailsFilter.js